import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import runModal from 'ui-library/runModal';

import CreateJellyfishModal from './CreateJellyfishModal';

function handleClickNewJellyfish(): void {
  runModal(CreateJellyfishModal, {});
}

export default function CreateJellyfishButton(): JSX.Element {
  return (
    <Tooltip text="Add jellyfish" placement={FloatingPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        icon="compose"
        onClick={handleClickNewJellyfish}
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}
